import styles from './Theme.module.scss';
import React, { useEffect } from 'react';
import { ReactComponent as SunIcon } from '../../../../assets/icons/sun.svg';
import { ReactComponent as MoonIcon } from '../../../../assets/icons/moon.svg';
import { useDispatch, useSelector } from 'react-redux';
import { changeTheme } from '../../../../store/actions/settings';
import LocalStorage, { LOCAL_STORAGE_KEYS } from '../../../../utils/localStorage';

const Theme = () => {
    const dispatch = useDispatch();
    const theme = useSelector(state => state.settings.theme);

    useEffect(() => {
        const userThemePreference = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.theme));
        dispatch(changeTheme(userThemePreference));
    }, []);

    const onThemeChange = e => {
        const theme = !e.target.checked;
        LocalStorage.setItem(LOCAL_STORAGE_KEYS.theme, theme);
        dispatch(changeTheme(theme));
    };

    return (
        <div className={styles.container}>
            <SunIcon className={styles.sunIcon} />
            <input
                className={styles.switch}
                checked={!theme}
                type='checkbox'
                id={'switch'}
                onChange={onThemeChange}
            />
            <label className={styles.switchLabel} htmlFor='switch' />
            <MoonIcon className={styles.moonIcon} />
        </div>
    );
};

export default Theme;
